var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgram1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.45 8.73L17.45 479.03L622.55 479.03L622.55 8.73L17.45 8.73ZM32 465.45L32 23.27L608 23.27L608 465.45L32 465.45Z",
    id: "b1Jw7bdOBz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.24 47.52L56.24 440.24L583.76 440.24L583.76 47.52L56.24 47.52ZM70.79 426.67L70.79 62.06L569.21 62.06L569.21 426.67L70.79 426.67Z",
    id: "cj4umXmf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91 570.67C2.91 594.91 22.3 615.27 47.52 615.27C102.21 615.27 539.73 615.27 594.42 615.27C618.67 615.27 639.03 595.88 639.03 570.67C639.03 565.24 639.03 521.79 639.03 516.36C410.18 516.36 226.91 516.36 2.91 516.36C2.91 527.22 2.91 565.24 2.91 570.67ZM401.45 558.06L264.73 558.06L278.3 530.91L387.88 530.91L401.45 558.06ZM593.45 600.73C538.76 600.73 101.24 600.73 46.55 600.73C30.06 600.73 16.48 587.15 16.48 570.67C16.48 568.02 16.48 554.76 16.48 530.91L261.82 530.91L241.45 572.61L424.73 572.61L404.36 530.91L623.52 530.91L623.52 570.67C614.46 590.71 604.44 600.73 593.45 600.73Z",
    id: "g3MW6Rf4x4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.28 387.67L484.23 328.05L402.47 248.07L448.55 202.99L259.77 168.09L293.96 354.22L341.53 307.69L423.28 387.67ZM369.77 249.52L451.53 329.5L421.8 358.59L340.04 278.61L307.34 310.6L286.53 197.17L402.47 217.53L369.77 249.52Z",
    id: "c3prAVLT4p"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1Jw7bdOBz",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1Jw7bdOBz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cj4umXmf",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cj4umXmf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3MW6Rf4x4",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3MW6Rf4x4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3prAVLT4p",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3prAVLT4p",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram1);
export default __webpack_public_path__ + "static/media/program-1.9f0fbbb309cc6971d68223408bb2c4c2.svg";
export { ForwardRef as ReactComponent };